<template>
  <!-- 数字农业·二级页面 -->
  <div>
    <div id="num_farming" ref="farming">
      <div class="echarts_border">
        <div class="btnBox">
          <div
            v-for="(item, index) in menuList"
            :key="index"
            :class="[isActive == index ? 'activeBtn' : 'btn']"
            @click="selectIndustry(index)"
          >
            <p class="btnTitle">{{ item.title }}</p>
          </div>
        </div>

        <!-- 制种 -->
        <seedProduction v-if="this.isActive == 0" />
        <!-- 奶产业 -->
        <cow v-if="this.isActive == 1" />
        <!-- 蔬菜 -->
        <vegetables v-if="this.isActive == 2" />
        <!-- 肉牛产业 -->
        <beefCattle v-if="this.isActive == 3" />
        <!-- 滩羊产业 -->
        <tanSheep v-if="this.isActive == 4" />
        <p class="text-center">数据来源：{{ Data_txt }}、{{ Data_txtTwo }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import beefCattle from "../digital_industry/beefCattle.vue";
import cow from "../digital_industry/cow.vue";
import seedProduction from "../digital_industry/seedProduction.vue";
import tanSheep from "../digital_industry/tanSheep.vue";
import vegetables from "../digital_industry/vegetables.vue";
export default {
  components: {
    seedProduction,
    beefCattle,
    cow,
    tanSheep,
    vegetables,
  },
  props: {},
  data() {
    return {
      menuList: [
        { title: "制种产业" },
        { title: "奶牛产业" },
        { title: "蔬菜产业" },
        { title: "肉牛产业" },
        { title: "羊产业" },
      ],
      isActive: 0,
      Data_txt: "",
      Data_txtTwo: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 选择产业
    selectIndustry(index) {
      this.isActive = index;
    },
    // 数据来源
    Sources() {
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[4].farming;
      this.Data_txtTwo = dataSources.data[4].production;
    },
  },
  created() {},
  mounted() {
    this.Sources();
  },
};
</script>

<style lang="less" scoped>
#num_farming {
  background: #15606e;
  border-top: 1px solid rgb(121, 226, 154);
}
.echarts_border {
  height: 39rem;
  overflow: auto;
  scrollbar-face-color: #0e4560;
}
.btnBox {
  margin: 34px 2rem;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
}
.btn {
  width: 15%;
  height: 39px;
  // opacity: 0.3;
  background: rgba(138,206,254,0.3);
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.activeBtn {
  width: 15%;
  height: 39px;
  // opacity: 0.47;
  background: rgba(0,48,82,0.47);
  border: 1px solid #3ef89c;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.btnTitle {
  font-size: 22px;
  font-family: PingFang-SC-Medium;
  color: #ebfaff;
  line-height: 39px;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/detail_farming/Num_farming.vue